import {authHeader} from "../util/auth-header";
import http from "../util/http-common";

export class VinUpdateService {

    static async retrieveVinFragment(vinFragment: string) {
        return http.get(
            `/cfadminvinadmin/api/v1/vin-pattern-update/retrieveVinFragment?vinFragment=${encodeURIComponent(vinFragment)}`,
            {headers: await authHeader()}
        );
    }

    static async newVinFragmentUpdate(data: any) {
        return http.put(
            `/cfadminvinadmin/api/v1/vin-pattern-update/vinFragmentUpdate`,
            data,
            {headers: await authHeader()}
        );
    }
}

export default VinUpdateService;
